import Cookies from 'universal-cookie'

export default class CookiesManager
{
    static instance = null
    
    cookies = null
    
    constructor()
    {
        this.cookies = new Cookies()
    }
    
    static getInstance()
    {
        if (this.instance === null)
            this.instance = new CookiesManager()
        
        return this.instance.cookies
    }
}